export const labelFont = {
  fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  fontSize: 14,
  fill: '#404040',
  fontWeight: 600,
  dy: 3,
};

export const connectionStyle = {
  stroke: '#ddd',
  strokeWidth: 1,
};

export const MAX_FONT_SIZE = 14;
export const MIN_FONT_SIZE = 12;

export const LABEL_CHAR_WIDTH = 10;
export const LABEL_CHAR_HEIGHT = 12;

export default {
  labelFont,
  MAX_FONT_SIZE,
  MIN_FONT_SIZE,
  LABEL_CHAR_WIDTH,
  LABEL_CHAR_HEIGHT,
};



// WEBPACK FOOTER //
// ./src/constants/chart.js